<template>
  <div class="new-rel">
    <el-select v-model="bindFormdataVal[relRadio.title + '_' + relRadio.type]"
             v-loadmore="loadmore"
             @focus="selectFocus"
             @blur="selectBlur"
             class="input-details new-rel-radio"
             :popper-class="isFocus ? 'rel-focus' : ''"
             @change="selectChange"
             @keyup="selectKeyUp($event)"
             :value-key="relRadio.selectTable && relRadio.selectTable === 'customization' && relRadio.isSource && relRadio.isSource === 2 ? relRadio.list[0].name : relRadio.selectTable && relRadio.selectTable === 'sys' ? relRadio.list[0].field : ''"
             :filterable="true"
             :multiple="isMom"
             :loading="loading"
             ref="todoSelect"
             :placeholder="selectName">
             <template v-if="relRadio.selectTable && relRadio.selectTable === 'sys'">
              <el-option
                    v-for="(item, inx) in options"
                    :key="inx"
                    :style="isTodo ? '' : {width: widthOption + 'px', maxWidth: widthOption + 'px'}"
                    :label="item[relRadio.list[0].field]"
                    :value="item">
                  </el-option>
            </template>
             <template v-else-if="relRadio.selectTable && relRadio.selectTable === 'customization' && relRadio.isSource && relRadio.isSource === 2">
              <el-option
                    v-for="(item, inx) in options"
                    :key="inx"
                    :style="isTodo ? '' : {width: widthOption + 'px', maxWidth: widthOption + 'px'}"
                    :label="item[relRadio.list[0].name]"
                    :value="item">
                  </el-option>
              </template>
             <template v-else>
              <el-option
                v-for="item in options"
                :key="item.approvingId"
                :style="isTodo ? '' : {width: widthOption + 'px', maxWidth: widthOption + 'px'}"
                :label="item.自定义标题"
                :value="item.approvingId">
              </el-option>
             </template>
    </el-select>
    <el-scrollbar v-if="isFocus" style="height:calc(100% - 46px);margin-top:6px;" ref="myScrollbar" v-scrollLoadmore="loadmore" v-loading="loading">
      <!-- <div v-for="(item, index) in options" :key="index" @click="selectChange(item)" class="rel-liste"> -->
      <div v-for="(item, index) in options" :key="index" @click="selectChange(relRadio.selectTable && relRadio.selectTable === 'customization' && relRadio.isSource && relRadio.isSource === 2 ? item : (item.approvingId || item))" class="rel-liste">
        <template v-if="relRadio.selectTable && relRadio.selectTable === 'sys'">{{ item[relRadio.list[0].field] }}</template>
        <template v-else-if="relRadio.selectTable && relRadio.selectTable === 'customization' && relRadio.isSource && relRadio.isSource === 2">{{ item[relRadio.list[0].name] }}</template>
        <template v-else>{{ item.自定义标题 }}</template>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  import { linkedSetEvent } from '@/api/global'
  import { apiGetreportdatalist } from '@/port/clientSide/formFillinPageChild/newRelRadio'
  import { sourceNewRel } from './js/relevancy'
  import { apiGetapprovaldashboardpreview } from '@/port/admins/instrument'
  import { getapiorganizationlist, getapiuserlist } from '@/port/clientSide/multipleChoice'
  import jsonType from '@/api/userConfig'
  import { getnoopenusertiplist, getdepttiplist } from '@/port/admins/organizationUser'
  import { apiGetapprovalreport } from '@/port/admins/report'

  export default {
    name: "newRelRadio",
    // newIndex 明细里面的下标  detailsType 明细的type scopeIndex 明细的当前第几行 userHide 提价后隐藏数据存储 approvalId 应用id
    props: ['relRadio', 'isMom', 'newIndex', 'bindVal', 'detailsType', 'scopeIndex', 'userHide', 'formdata', 'approvalId', 'isFocus', 'isTodo', 'AuditList'],
    data() {
      return {
        debounce: null,  //防抖
        selectOptions: [],
        pagesize: 15,
        curpage: 1,
        value: '',
        options: [],
        momData: [],
        selectName: '请选择',
        loading: false,
        userType: {},
        organizationType: [],
        bindFormdataVal: {}, //formdata数据
        userHideVal: {},
        isSpace: false, // 是否从空间进入
        isUpace: false, // 是否从空间进入
        widthOption: 0
      }
    },
    watch: {
      // formData数据
      bindVal: {
        handler (val) {
          if (val) {
            this.bindFormdataVal = val
          }
        },
        immediate: true,
        deep: true
      },
      userHide: {
        handler (val) {
          if (val) {
            this.userHideVal = val
          }
        },
        immediate: true,
        deep: true
      },
    },
    created () {
      const spaceId = this.$route.query.spaceid
      const spaceStatus = this.$route.query.space
      const upaceId = this.$route.query.upaceid
      const upaceStatus = this.$route.query.upace
      if (typeof(spaceId) !== 'undefined' || spaceStatus){
        this.isSpace = true
      }
      else if (typeof(upaceId) !== 'undefined' || upaceStatus){
        this.isUpace = true
      }
    },
    //自定义指令
    directives: {
      'loadmore': {
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
          SELECTWRAP_DOM.addEventListener('scroll', function () {
            /**
             * scrollHeight 获取元素内容高度(只读)
             * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
             * clientHeight 读取元素的可见高度(只读)
             * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
             * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
             */
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      },
      'scrollLoadmore': {
        bind(el, binding) {
          const SELECTWRAPs_DOM = el.querySelector('.el-scrollbar .el-scrollbar__wrap');
          SELECTWRAPs_DOM.addEventListener('scroll', function () {
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          })
        }
      }
    },
    methods: {
      // 初始化手动触发一次加载
      openS () {
        if (this.options.length === 0) {
          this.selectFocus()
        }
      },
      selectChange(e) {
        console.log('选中值', e)
        //多选暂时不做
        if (this.relRadio.type === 'new-rel-radio') {
          //获取数据
          let item = this.options.find(val => {
             if(e === val.approvingId) {
              return val;
            }
          });
          if (this.isTodo) {
            // 门户那边列表操作  单独修改数据
            this.$emit('changeRefTodo', JSON.parse(JSON.stringify(item)))
            this.bindFormdataVal[this.relRadio.title + '_' + this.relRadio.type] = item['自定义标题']
            return
          }
          if (this.relRadio.selectTable && this.relRadio.selectTable === 'customization' && this.relRadio.isSource && this.relRadio.isSource === 2) {
            console.log('判断是否回抛的数据', e)
            // 判断是否工坊数据，是的话用名称转一次
            for (const its of this.relRadio.list) {
              e[its.title + '_' + its.type] = e[its.name]
            }
            item = e
            this.bindFormdataVal[this.relRadio.title + '_' + this.relRadio.type] = item[this.relRadio.list[0].name];
          } else if (this.relRadio.selectTable && this.relRadio.selectTable === 'sys') {
            if (this.relRadio.relFormId === 'user') {
              // 用户表图片格式固定的
              e.facephoto = e.facephoto ? [{Response: e.facephoto, url: this.$imgurl + e.facephoto, name: (e.facephoto).split('-').at(-1)}] : []
              e.avatar = e.avatar ? [{Response: e.avatar, url: this.$imgurl + e.avatar, name: (e.avatar).split('-').at(-1)}] : []
              if (JSON.stringify(this.userType) !== '{}') e.type = this.userType[e.type] || '无类型'
            } else {
              e.type = this.dealType(e.type)
            }
            item = e
            this.bindFormdataVal[this.relRadio.title + '_' + this.relRadio.type] = item[this.relRadio.list[0].field];
          }
          
          console.log('选择的数据', item, e)
          
          let types = this.relRadio.title + '_' + this.relRadio.type;
          
          if ((!this.relRadio.selectTable || this.relRadio.selectTable === 'customization') && (!this.relRadio.isSource || this.relRadio.isSource === 1)) {
            // 应用的话
            // eslint报错，先注释
            // this.relRadio.approvingId = item.approvingId;

            this.bindFormdataVal[types] = item.自定义标题;

            if (this.relRadio.datahided == 2) {
              let date = {
                title:this.relRadio.title,
                linkedApprovingId:e
              };

              // 提交后隐藏数据存储
              if (this.relRadio.datahided === 2) {
                if (this.detailsType) {
                  let types = this.detailsType.split('_')[0];
                  // 不存在就自己添加
                  if (!this.userHideVal[types]) {
                    this.userHideVal[types] = [];
                  }
                  if (!this.userHideVal[types][this.scopeIndex]) {
                    this.userHideVal[types][this.scopeIndex] = {};
                  }
                  this.userHideVal[types][this.scopeIndex][this.relRadio.title] = date;
                } else {
                  this.userHideVal[this.relRadio.title] = date;
                }
              }

            }
          }

          if (this.relRadio.list && this.relRadio.list.length > 0) {
            let list = this.relRadio.list;
            for (let i = 0; i < list.length; i++) {
              let listType = list[i].title + '_' + list[i].type;
              const isSource = this.relRadio.selectTable && this.relRadio.selectTable === 'customization' && this.relRadio.isSource && this.relRadio.isSource === 2 ? list[i].name : this.relRadio.selectTable && this.relRadio.selectTable === 'sys' ? list[i].field : ''
              // 多选框要改成数组格式
              if (list[i].type === 'checkbox') {
                try{
                  // 关联单选，如果数组长度是1的时候会报错，做如下修改
                  let parsedValue = JSON.parse(!isSource && item ? item[list[i].titleId] : item[isSource]);
                  this.bindFormdataVal[listType] = Array.isArray(parsedValue) ? parsedValue : [parsedValue];
                  // this.bindFormdataVal[listType] = JSON.parse(item[list[i].titleId]);
                }
                catch (e) {
                  this.bindFormdataVal[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
                  // this.bindFormdataVal[listType] = item[list[i].titleId];
                }
                if (typeof item[list[i].titleId] === 'string') {
                  let listVal = [];
                  try{
                    listVal = (!isSource && item ? item[list[i].titleId] : item[isSource]).split(',');
                    // listVal = (item[list[i].titleId]).split(',');
                  }
                  catch (e) {
                    console.log('转格式错误')
                  }
                  this.bindFormdataVal[listType] = listVal;
                }
              } else if (list[i].type === 'relation-user') {
                try{
                  this.bindFormdataVal[listType] = JSON.parse(!isSource && item ? item[list[i].titleId] : item[isSource]);
                  // this.bindFormdataVal[listType] = JSON.parse(item[list[i].titleId]);
                }
                catch (e) {
                  this.bindFormdataVal[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
                  // this.bindFormdataVal[listType] = item[list[i].titleId];
                }
              } else {
                console.log('值给错了', listType, list[i].titleId, item, isSource, !isSource,'-', !isSource && item)
                this.bindFormdataVal[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
                // this.bindFormdataVal[listType] = item[list[i].titleId];
              }
            }
            this.$emit('onLinkageNewRel', this.relRadio.list, this.newIndex,this.scopeIndex);
          }
        }
      },
      selectKeyUp(e) {
        this.value = e.target.value ? e.target.value : '';
        clearTimeout(this.debounce);
        this.debounce = null;
        this.debounce = setTimeout(() => {
          this.curpage = 1;
          this.pageSize = 15;
          this.getList('search');
        }, 200);
      },
      loadmore() {
        this.curpage += 1;
        this.getList()
      },
      selectBlur() {
        this.selectName = '请选择';
      },
      selectFocus(e) {
        console.log('获取焦点', e)
        if (e) {
          const w = e.target.getBoundingClientRect()
          this.widthOption = w.width
        }
        this.selectName = '请搜索';
        this.curpage = 1;
        this.pageSize = 15;
        if (this.options.length === 0 || Number(this.relRadio.datahided) === 2||this.relRadio.dataconfig&&this.relRadio.dataconfig.setUpValue==1) {
          this.getList();
        }
      },
      //多选值处理
      momHandle(e) {
        let arr = [];
        for (let i in e) {
          if (typeof e[i] === 'number') {
            //去查找对应数据回来
            let item = this.options.find(val => { if (val.approvingId === e[i]) return val; });
            arr.push(item.自定义标题);
          } else {
            arr.push(e[i]);
          }
        }
        return arr;
      },
      //关联单选聚焦触发
      onCondition(item){
        console.log('=======',item)
        if(item.dataconfig&&item.dataconfig.setUpValue==1 || item.type === 'new-rel-radio' && item.dataconfig && item.dataconfig.setUpValue == 7){//如果有配置联动
          let param = false
          if(item.dataconfig.linked&&item.dataconfig.linked.conditional){
            param = linkedSetEvent(item.dataconfig,this.formdata,{index:item.thisIndex})
            if(param){
              delete param.dataconfig
            }
          }
          item.condition = param?param:{}//有配置联动，数据没填完使用
        }
        return JSON.parse(JSON.stringify(item))
      },
      async getList(e) {
        let relRadio = JSON.parse(JSON.stringify(this.relRadio));
        let param = null;
        let par = null;
        // 如果是明细
        if (this.detailsType) {
          relRadio.findex = this.newIndex;
          relRadio.thisIndex = this.scopeIndex;
        }
        param = this.onCondition(relRadio);

        if (param && param.relWidDataLook) {
          par = {
            relWidDataLook: param.relWidDataLook,
            approvalId: this.relRadio.relFormId,
            datahided: this.relRadio.datahided,
            appid: this.$route.query.approvalId || this.approvalId,
            curpage:  this.curpage,
            pagesize: 100,
            type: 0,
            cateId: -1
          }
          if (param.dataconfig) par.dataconfig = JSON.stringify(param.dataconfig);
          if (param.condition) par.condition = JSON.stringify(param.condition);
          if (e) par.key = this.value;
        } else {
          par = {
            relWidDataLook: this.relRadio.relWidDataLook ? this.relRadio.relWidDataLook : 1,
            approvalId: this.relRadio.relFormId,
            curpage: this.curpage,
            pagesize: 100,
            datahided: this.relRadio.datahided,
            appid: this.$route.query.approvalId || this.approvalId,
            query: "{}",
            key: this.value,
          };
          //如果有联动，需要回父级调用联动
          if(this.relRadio.dataconfig&&this.relRadio.dataconfig.setUpValue==1){
            let relRadios = JSON.parse(JSON.stringify(this.relRadio));
            relRadios.thisIndex = this.scopeIndex;
            this.$emit('onRelCondition', relRadios);
            par.dataconfig = JSON.stringify(this.relRadio.dataconfig)
            par.condition = JSON.stringify(this.relRadio.condition)
          }
        }
        if (this.curpage === 1) this.loading = true;
        if (this.relRadio.selectTable && this.relRadio.selectTable === 'sys' && this.relRadio.relFormId === 'org') {
          if (this.organizationType.length === 0) this.getOrganizationType()
          await this.getOrgList()
          this.loading = false;
        } else if (this.relRadio.selectTable && this.relRadio.selectTable === 'sys' && this.relRadio.relFormId === 'user') {
          if (JSON.stringify(this.userType) === '{}') this.getUserType()
          await this.getUserList()
          this.loading = false
        } else if (this.relRadio.selectTable && this.relRadio.selectTable === 'customization' && this.relRadio.isSource && this.relRadio.isSource === 2) {
          console.log('这里是工坊的搜索', this.relRadio)
          const re = await apiGetapprovalreport({ approvalReportId: this.relRadio.relFormId }).catch(err => { console.log(err) })
          let list = []
          if (re.code === 0) {
            const source = JSON.parse(re.data.config)
            const sourceInd = source.findIndex(it => it.type === 'output')
            list = source[sourceInd].datas || []
          }
          const search = []
          if ((this.value || this.value === 0) && this.relRadio.list && this.relRadio.list.length > 0) {
            // 有搜索值的话需要传下去使用
            const obsSearch = {
              type: 'filter',
              dataconfig: {
                rel: 'and',
                where: [
                  {
                    field: this.relRadio.list[0].titleId,
                    relation: 'like',
                    value: this.value
                  }
                ]
              }
            }
            search.push(obsSearch)
          }
          // 拼接工坊值
          const config = sourceNewRel(this.relRadio, search, 'titleId', list, this.formdata, this.AuditList)
          // const config = sourceSearch(this.relRadio, [], 'titleId')
          console.log('工坊拼接数据', config)
          apiGetapprovaldashboardpreview({
            curpage: this.curpage,
            pagesize: this.pageSize,
            config: config,
            nodeId: config[config.length- 1].id
          }).then(res => {
            console.log('工坊数据查询', res)
            if (res.code === 0) {
              const listObj = {}
              for (const s of (this.relRadio.list || [])) {
                const sName = s.titleId.split('.')
                listObj[sName[0]] = this.tObj(sName.slice(1), listObj[sName[0]] ? listObj[sName[0]] : {}, s.titleId)
                if (sName[0] !== s.name) listObj[s.titleId] = s.name
              }
              console.log('工坊的结构位置数据', listObj)

              // 工坊查询出来的手动给一个 approvingId 用作数据对比
              res.data = res.data.map(its => {
                its.approvingId = this.approvalId
                its = this.sObj(its, listObj)
                return its
              })
              if (this.curpage !== 1) {
                this.$set(this, 'options', this.options.concat(res.data))
              } else {
                this.$set(this, 'options', res.data)
              }
              console.log('查询数据', this.curpage, this.options)
            }
            this.loading = false;
          }).catch(err => { console.log(err) })
        } else if ((!this.relRadio.selectTable || this.relRadio.selectTable === 'customization') && (!this.relRadio.isSource || this.relRadio.isSource === 1)) {
          apiGetreportdatalist(par).then(res => {
          if (res.code === 0) {
            if (this.curpage !== 1) {
              this.options = this.options.concat(res.data);
            } else {
              this.options = res.data;
            }
          }
          this.loading = false;
        }).catch(error => {
          console.log(error);
        })
      }
    },
    // 扁平化数据
    sObj (val, config) {
      for (const i in val) {
        if (typeof val[i] === 'object' && typeof config[i] === 'object') {
          val = {
            ...this.sObj(val[i], config[i]),
            ...val
          }
        } else {
          val[config[i]] = val[i]
        }
      }
      return val
    },
    // 做返回结构
    tObj (arr, obj, value) {
      if (!arr || arr.length === 0) return value
      const key = arr[0]
      obj[key] = arr.length > 1 ? this.tObj(arr.slice(1), {}, value) : value
      return obj
    },
    async getUserList () {
      // 获取用户数据
      const { code, data } = await getapiuserlist({ curpage: this.curpage, pagesize: this.pageSize }).catch(e => { console.log(e) })
      console.log('获取用户数据列表', data)
      if (code === 0) {
        // 值类型转化
        let ars = this.setUserTitle(data)

        if (this.curpage !== 1) {
          this.$set(this, 'options', this.options.concat(ars))
        } else {
          this.$set(this, 'options', ars)
        }
      }
    },
    async getOrgList () {
      // 获取组织数据
      const obj = { pid: -1, curpage: this.curpage, pagesize: this.pageSize }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      const { code, data } = await getapiorganizationlist(obj).catch(e => { console.log(e) })
      console.log('组织结果', code, data)
      if (code === 0) {
        if (this.curpage !== 1) {
          this.$set(this, 'options', this.options.concat(data))
        } else {
          this.$set(this, 'options', data)
        }
      }
    },
    dealType (type) {
        const itype = this.organizationType.find(item => item.deptTipId === type) || {}
        return itype.name
    },
    // 获取组织类型
    async getOrganizationType () {
        const { data, code, msg } = await getdepttiplist({
            curpage: 1,
            pagesize: 9999
        })
        if (code === 0) {
            this.organizationType = data
        } else {
            this.$message.error(msg)
        }
    },
    // 用户数据标签转化
    setUserTitle (data) {
      return data.map(its => {
          its.idcardtype = !its.idcardtype ? '其他' : jsonType.identityTypes[its.idcardtype - 1].label
          its.sex = !its.sex && its.sex !== 0 ? '' : jsonType.gender[its.sex].label
          // if (JSON.stringify(this.userType) !== '{}') its.type = this.userType[its.type] || '无类型'
          // for (const i of this.itemsKey) {
          //     its[i.title] = its[i.field]
          //     its[i.name] = its[i.field]
          // }
          return its
      })
    },
    async getUserType () {
        const { code, data } = await getnoopenusertiplist({curpage: 1, pagesize: 999999}).catch(err => { console.log(err) })
        if (code === 0) {
            const userType = {}
            for (const i of data) {
                userType[i.keytype] = i.name
            }
            this.userType = userType
        }
    },

  }
}
</script>

<style scoped lang="scss">
  .new-rel-radio {
    width: 100%;
    border: none;
  }
  .new-rel-radio input {
    height: 30px;
  }
  /* .new-rel-radio input:nth-child(1) {
    border: 1px dashed #D2D2D2;
  } */
  .rel-focus {
    display: none;
  }
  .new-rel {
    height: 100%;
    padding-bottom: 10px;
  }
  .rel-liste {
    padding-top: 6px;
    padding-bottom: 6px;
    color: #333333;
    cursor: pointer;
    padding-left: 6px;
    padding-right: 6px;
    &:hover {
      color: #4e86ff;
    }
    &.active {
      color: #4e86ff;
    }
  }
</style>
